"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_select_1 = require("react-select");
var OptimizedOption = /** @class */ (function (_super) {
    __extends(OptimizedOption, _super);
    function OptimizedOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptimizedOption.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(react_select_1.components.Option, __assign({}, this.props, { children: this.props.children })));
    };
    return OptimizedOption;
}(React.Component));
exports.default = OptimizedOption;
//# sourceMappingURL=OptimizedOption.js.map